export interface BackofficeSection {
  name: string;
  url: string;
  role: string;
  icon: string;
}

export enum BackofficeRole {
  ANALYTICS = 'ANALYTICS',
  ANALYSIS = 'ANALYSIS',
  INSURANCE_COMISSIONS = 'INSURANCE_COMISSIONS',
  POLICIES = 'POLICIES',
  CUSTOMER_CARE = 'CUSTOMER_CARE',
  HOMEOWNER_MANAGER = 'HOMEOWNER_MANAGER',
  EXTERNAL_LAWYER = 'EXTERNAL_LAWYER',
  SINISTERS = 'SINISTERS'
}

export enum BackofficeDocumentPipeFunction {
  TYPE,
  VALIDATED
}

export enum BackofficeSectionsEnum {
  ANALYSIS = 'ANALYSIS',
  AML = 'AML',
  CUSTOMER_CARE = 'CUSTOMER_CARE',
  POLICIES = 'POLICIES',
  SINISTERS = 'SINISTERS',
  CANCELED = 'CANCELED',
  INSURANCE_COMISSIONS = 'INSURANCE_COMISSIONS',
  USER_SEARCH = 'USER_SEARCH',
  CADASTRAL_REFERENCE = 'CADASTRAL_REFERENCE',
  EXTRA_DOCUMENTATION = 'EXTRA_DOCUMENTATION',
  EXPERIAN_SEARCHES = 'EXPERIAN_SEARCHES',
  PORTFOLIO_ROLES = 'PORTFOLIO_ROLES',
  ANALYTICS = 'ANALYTICS',
  TEMPLATES_MANAGEMENT = 'TEMPLATES_MANAGEMENT',
  INVOICE_MANAGEMENT = 'INVOICE_MANAGEMENT',
  HOMEOWNER_MANAGEMENT = 'HOMEOWNER_MANAGEMENT',
  TRANSFERS = 'TRANSFERS'
}
